'use client'

import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { faIR } from '@mui/x-date-pickers/locales'
import dayjs from 'dayjs'

interface LocalizationProviderWrapperProps {
  children: React.ReactNode
}

export default function LocalizationProviderWrapper({
  children,
}: LocalizationProviderWrapperProps) {
  dayjs.locale('fa')

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale='fa'
      localeText={
        faIR.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      {children}
    </LocalizationProvider>
  )
}
